import { t as translateDate } from './translate-date.js';
import { U as Url } from './url.min.js';
import './index2.js';

/**
 * **Mirai**
 *
 * @exports bs_7
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  engine._isReact = function () {
    return !!(document.querySelector && (document.querySelector('[data-reactroot]') || document.querySelectorAll('[data-mirai-engine]').length));
  };

  engine._reactIsLoading = function () {
    return !!(document.querySelector && document.querySelector('.mi-rs.loading, .mi-rs.waiting'));
  };

  engine._reactGetDevice = function () {
    let device;

    if ((document.querySelector('.mi-rs')
      || document.querySelector('body.is-desktop')
      || thn.dataLayerHelper.get('device') === 'DESKTOP_TABLET')
      && !window.location.search.match(/mobile/i)
      && !document.querySelector('body.is-mobile, body.bookingstep-mobile')
    ) {
      device = 'DESKTOP';
    } else if (document.querySelector('body.is-mobile, body.bookingstep-mobile')
      || (thn.dataLayerHelper.get('device') === 'MOBILE')
      || (thn.dataLayerHelper.get('mirai.data.device') === 'MOBILE')
      || window.location.search.match(/mobile/i)
    ) {
      device = 'MOBILE';
    }

    return device;
  };

  engine._reactCreateLoadingObserver = function (callback) {
    // desktop || mobile selectors
    const element = document.querySelector && (document.querySelector('.mi-rs') || document.querySelector('div[data-mirai-engine="mirai_rs"]'));

    if (element && !thn.miraiLoadingObserver) {
      // Initial state
      const isMobile = engine._reactGetDevice() === 'MOBILE';

      thn.data.miraiLoading = isMobile ? true : engine._reactIsLoading();

      thn.miraiLoadingObserver = thn.debounce(function thnMiraiLoadingObserver() {
        const miraiLoading = engine._reactIsLoading();

        if (thn.data.miraiLoading && !miraiLoading) {
          // BE just loaded
          if (callback) { callback(); }
        }

        thn.data.miraiLoading = miraiLoading;
      }, 150);

      thn.observeDom(element, thn.miraiLoadingObserver, {
        childList: isMobile,
        subtree: isMobile,
        characterData: false,
        attributes: true,
        attributeFilter: ['class'],
      });

      thn.pageUnload(function () {
        thn.stopObserveDom(element, thn.miraiLoadingObserver);
        delete thn.miraiLoadingObserver;
        delete thn.data.miraiLoading;
      });
    }

  };

  /**
     * @memberOf module:bs_7
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {

    const container = document.querySelector('[data-mirai-engine="mirai_rs"]');
    if (container) {
      let refreshRoomsAndRatesPage = thn.debounce(() => {
        const loader = document.querySelector('.loading, .mi-loading-overlay');
        const calendar = document.querySelector('.DateRangePicker_picker, #preloader');
        if (!thn.isVisible(loader) || !thn.isVisible(calendar)) {
          thn.pageCheck();
        }
      }, 500);
      thn.observeDom(container, refreshRoomsAndRatesPage, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      thn.shutdown(() => {
        refreshRoomsAndRatesPage.cancel();
        thn.stopObserveDom(container, refreshRoomsAndRatesPage);
        refreshRoomsAndRatesPage = null;
      });
    }

    const bodyEl = document.querySelector('body');
    if (!engine._isReact() && window.location.pathname.match(/mobile/i)) {
      if (!document.querySelector) { return; }

      if (bodyEl && !thn.miraiMobileObserverFunc) {

        thn.miraiMobileObserverFunc = thn.debounce(function thnMiraiMobileObserverFunc() {
          const previousPage = thn.data.pageName;
          // Check the page
          thn.pageCheck();

          // If we are back in R&R reset PW
          if (thn.data.pageName === 'Rooms and Rates' && previousPage !== thn.data.pageName) {
            // Try to refresh the PW data
            if (thn.widgets.price.refresh() && !thn.widgets.price.isSet()) {
              // Hide PW if data couldn't be set
              thn.widgets.price.hide();
            }
          }
        }, 200);

        thn.observeDom(bodyEl, thn.miraiMobileObserverFunc, {
          childList: true,
          subtree: false,
          characterData: false,
          attributes: false,
        });

        thn.shutdown(function () {
          thn.stopObserveDom(bodyEl, thn.miraiMobileObserverFunc);
          delete thn.miraiMobileObserverFunc;
        });
      }
    }

    // Three Corners Hotels
    if (thn.data.accountUserId === 1044843) {
      if (window.dataLayer && thn.data.pageType !== 'booking_system_page') {
        const refreshPage = thn.debounce(thn.pageCheck, 700);
        // eslint-disable-next-line no-new
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (_model, message) {
          if (message.event === 'gtm.click' && message['gtm.element']?.ariaCurrent === 'page') {
            refreshPage();
          }
        }, true);
        thn.shutdown(() => {
          dataLayerHelper.cancel();
          dataLayerHelper = null;
        });
      }
    }

    // Princess Hotels - force page check after user login
    if (thn.data.accountUserId === 1032182) {
      if (window.dataLayer) {
        const refreshPage = thn.debounce(() => {
          thn.pageCheck({ force: true });
        }, 800);
        // eslint-disable-next-line no-new
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (_model, message) {
          if (message[1] === 'login') {
            refreshPage();
          }
        }, true);
        thn.shutdown(() => {
          dataLayerHelper.cancel();
          dataLayerHelper = null;
        });
      }
    }

    const isKategoraHotelsMobile = [1033281, 1041893].includes(thn.data.accountUserId) && thn.data.media.name === 'mobile';
    const sideMenuContainer = document.querySelector('#Sidemenu, .home');

    if (isKategoraHotelsMobile) {
      if (sideMenuContainer) {
        let refreshPage = thn.debounce(thn.pageCheck, 400);
        thn.observeDom(sideMenuContainer, refreshPage, {
          attributes: true,
        });

        thn.shutdown(() => {
          refreshPage.cancel();
          thn.stopObserveDom(sideMenuContainer, refreshPage);
          refreshPage = null;
        });
      }
    }
  };

  /**
     * @memberOf module:bs_7
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    const url = new Url(ctx.baseUrl);

    // desktop classic - https://www.hostallasfuentes.com/en/bookingstep1/?idtokenprovider=50013896&lang=en&checkin=26%2F02%2F2020&nights=1&show_calendar=true&hsri=02040&bookinghost=&home=https%3A%2F%2Fwww.hostallasfuentes.com%2F&bookingpage=&clientCode=&roomTypeId=&securepage=&maxNights=32&step=1&currency=EUR#%26rooms
    // mobile classic - https://reservation.mirai.com/XMAS/reservation/bookingstep1_mobile.htm?idtokenprovider=100375536&idchain=&chainSelector=&lang=es&checkin=13%2F3%2F2020&nights=3&show_calendar=true&hsri=02040&home=http%3A%2F%2Fdormirdcine.com%2F&engine=&bookinghost=&bookingpage=&clientCode=&mobile=true&step=1&parties=W3siYWR1bHRzIjoiMiIsImNoaWxkcmVuIjpbXX1d&startProcess=true#/XMAS/reservation/show_booking_rooms_mobile.htm?idtokenprovider=100375536&idchain=&chainSelector=&lang=es&checkin=13%2F3%2F2020&nights=3&show_calendar=true&hsri=02040&home=http%3A%2F%2Fdormirdcine.com%2F&engine=&bookinghost=&bookingpage=&clientCode=&mobile=true&step=1&parties=W3siYWR1bHRzIjoiMiIsImNoaWxkcmVuIjpbXX1d&startProcess=true&gtmLoaded=true
    // react - https://sansebayhotel.com/bookingstep1.en.html?idtokenprovider=100376061&lang=en&nights=3&checkin=27%2F02%2F2020&step=1&home=http%3A%2F%2Fsansebayhotel.com%2F&currency=EUR

    // valid engine URL
    if (url.path.match(/bookingstep|reservation-step|bookings-step|reservas-paso|booking-step|step1/)) {
      // React URP
      if (engine._isReact() && url.path.match(/bookingstep2/)) {
        url.path.replace('bookingstep2', 'bookingstep1');
      }

      // Delete bookingstep1-mobile on desktop
      if (thn.data.media.name !== 'mobile') {
        url.path = url.path.replace(/bookingstep1-mobile/, 'bookingstep1');
        delete url.query.device;
        delete url.query.mobile;
      }

      // With this address Mirai redirects to the proper URL depending on the device
      // Original: https://room-matehotels.com/bookingstep1-mobile.php?currency=EUR&idtokenprovider=100375832&idchain=500814&parties=W3siYWR1bHRzIjoiMiIsImNoaWxkcmVuIjpbXX1d&checkin=19%2F10%2F2020&nights=1096&lang=es&clientCode=&hotelIds=100375832&_ga=2.268374218.579827303.1598521876-2111047735.1598521876&mobile=true&step=1&home=https%3A%2F%2Froom-matehotels.com%2F
      // Convert to: https://reservation.mirai.com/XMAS/reservation/miraiFrontDispatcher.htm?idtokenprovider=100375857&idchain=500814&parties=W3siYWR1bHRzIjoiMiIsImNoaWxkcmVuIjpbXX1d&checkin=30/09/2020&nights=1&lang=en&clientCode=&home=https://room-matehotels.com&hotelIds=100375857
      // Potencially this should apply to any Mirai Hotel, let's test it with RoomMate
      if (thn.data.accountUserId === 1033083) { // RoomMate
        url.host = 'reservation.mirai.com';
        url.path = '/XMAS/reservation/miraiFrontDispatcher.htm';
      }

      if (thn.data.accountUserId === 1037953) { // Pestana Hotels
        url.host = 'www.pestana.com';
        url.path = '/step1';
      }

      url.query.checkin = '[date_begin]';
      url.query.nights = '[nights]';
      url.query.currency = '[currency]';
      url.query.lang = '[language]';

      if (ctx.data.dateBegin && ctx.data.dateEnd) {
        ctx.newData.nights = thn.daysBetween(ctx.data.dateBegin, ctx.data.dateEnd);
      }
      if (!ctx.newData.nights) {
        ctx.newData.nights = thn.parseUrlParameter('nights');
      }
      if (!ctx.newData.dateBegin) {
        ctx.newData.dateBegin = thn.parseUrlParameter('checkin') || thn.dataLayerHelper.get('mirai.data.checkin');
      }
      if (!ctx.newData.currency) {
        const currency = document.querySelector('.mim-header__currency-selector option.is-selected')
          || document.querySelector('.mi-rs-currency-select');
        ctx.newData.currency = currency && thn.getCurrencyCode(currency.textContent.split('-')[0].trim() || '');
      }
      ctx.newData.dateBegin = (ctx.newData.dateBegin || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

      ctx.newUrl = url.decode(url.toString());
    } else {
      ctx.newUrl = '';
    }

    return ctx;
  };
  /**
     * @memberOf module:bs_7
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {
    return new Promise(function (resolve, reject) {

      let lang;

      // Avoid obtaining the language from the URL because is always in french
      // Riad Assala - 1025514
      if (thn.data.propertyId === 1025514) {
        resolve('fr');
      }

      lang = thn.parseUrlParameter('lang');
      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }

      lang = window.location.pathname.match(/\.(es|en|fr|ru|de|it|pt)\./);
      if (lang && ctx.langs.test(lang[1])) {
        resolve(lang[1]);
        return;
      }

      if (thn.data.accountUserId === 1036469 && !lang) {
        resolve('es');
        return;
      }

      // Mona Lisa Group
      if ([1033094].includes(thn.data.accountUserId)) {
        resolve('fr');
        return;
      }

      if ([1025184, 1014392, 1002409, 1035301, 1055393, 1077147, 1077148, 1091365].includes(thn.data.hotelId)) {
        resolve('es');
        return;
      }

      if (thn.data.hotelId === 1077145) {

        lang = (document.querySelector('.lang__switch span.active').textContent || {});
        lang = lang === '中文' ? 'zh' : lang;

        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      if ([1016831, 1016832].includes(thn.data.propertyId)) {

        const langEl = document.querySelector('a.language');
        if (langEl) {
          lang = langEl.textContent.toLowerCase();
          if (lang && ctx.langs.test(lang)) {
            resolve(lang);
            return;
          }
        }
      }

      if (thn.data.hotelId === 1002387 && !!document.querySelector('#clientName')) {

        lang = window.language;
        if (ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      // This has to be always before the last if statement (window.location.pathname.match(ctx.urlRe),
      // since it creates issues when bad ISO2 translations are in found in the url
      // IE:
      // url: https://www.pestana.com/ar/hotel/pestana-dom-joao
      // "ar" for argentinian spanish (should be "es") as "ar" is for arabian
      if (document.documentElement.lang) {
        resolve(document.documentElement.lang.substr(0, 2));
        return;
      }

      lang = window.location.pathname.match(ctx.urlRe);
      if (lang && ctx.langs.test(lang[1])) {
        resolve(lang[1]);
        return;
      }

      reject('no_language');
    });
  };

  /**
     * @memberOf module:bs_7
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {
    let isLogged = false;

    /**
         * Chains [Ayre & Only You, Garden Hotels, Smy Hotels, Hospes Hoteles, My Story Hotels, Stil Hotels,
         * Hoteles Porcel, HCC Hotels, Princess Hotels]
         * */

    const userName = (document.querySelector('.mi-club-login__access-text, .mi-club-login__access-icon, .mim-club-login__access-icon')// Princess Hotels
      || document.querySelector('.popover-personLogin-content-links')
      || document.querySelector('#capalog.active'))?.textContent
      || document.querySelector('[data-role=account]')?.textContent // Pestana BE
      || document.querySelector('.js-userInfo'); // Pestana Homepage

    isLogged = !!userName;
    return isLogged;
  };

  /**
     * @memberOf module:bs_7
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange() {

    if (thn.data.propertyId === 1027780) {
      thn.pageCheck();
    }
  };

  /**
     * @memberOf module:bs_7
     * @see {@link onHashChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onHashChange = function onHashChange(ctx) {
    // In non-react mobile version, the page changes are handled in boot
    if (!engine._isReact() && window.location.pathname.match(/mobile/i)) {
      return;
    }

    // Define a debounced reset page function
    if (!thn.miraiResetPage) {
      thn.miraiResetPage = thn.debounce(function thnMiraiResetPage() {
        thn.logger.debug('*************** RESET PAGE **************');

        thn.widgets.price.remove();
        thn.widgets.review.remove();
        thn.pageCheck();
      }, 1500);

      thn.shutdown(function () {
        delete thn.miraiResetPage;
      });
    }

    // When the hash changes, recheck the page
    // except on the cookie alert hash change, or when a user opens or close a photo
    if (!window.location.hash.match(/cookies-alert-wrapper|&gid=1&pid=1|^$/)) {
      thn.miraiResetPage();
    }
  };

  /**
     * @memberOf module:bs_7
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    if (engine._isReact()) {
      thn.data.miraiReactInitialized = false;

      thn.miraiReactInit = function () {
        // After loading, recheck language and refresh PW
        thn.languageCheck().then(function ({ changed }) {
          if (!changed) {
            thn.pageCheck();

            // Reset PW if we still are in R&R
            if (['Rooms and Rates', 'Packages'].includes(thn.data.pageName)) {
              ctx.widget.update();
            }
          }
        });

        // Detect currency changes on desktop and mobile
        const currencyEl = document.querySelector('.mi-rs-currency-select .mi-dropdown-btn') || document.querySelector('.mim-header__currency-selector');
        if (currencyEl) {
          thn.miraiCurrencyObserver = thn.debounce(function thnMiraiCurrencyObserver() {
            ctx.widget.logger.debug('*************** Currency Changed **************');
            setTimeout(function () {
              ctx.widget.update();
            }, 1000);
          }, 250);

          thn.observeDom(currencyEl, thn.miraiCurrencyObserver, {
            childList: false,
            subtree: true,
            characterData: true,
            attributes: true,
          });

          thn.pageUnload(function () {
            thn.stopObserveDom(currencyEl, thn.miraiCurrencyObserver);
            delete thn.miraiCurrencyObserver;
          });
        }

        // Detect occupation changes
        if (document.querySelector('.mi-rs-room-occupation-btn')) {
          // Capture all clicks and check if the target is a change occupation button
          document.querySelector('body').addEventListener('click', function (evt) {
            if (evt.target.classList.contains('mi-rs-modal-occupation-btn')
              || evt.target.closest('.mi-rs-modal-occupation-btn')
            ) {
              ctx.widget.logger.debug('*************** Guests Changed **************');
              setTimeout(function () {
                if (ctx.widget.refresh() && ctx.widget.isSet()) {
                  ctx.widget.hide();
                }
              }, 1000);
            }
          }, true);
        }
        thn.data.miraiReactInitialized = true;
      };

      // Init if BE is loaded
      if (!engine._reactIsLoading() && !thn.data.miraiInitialized) {
        thn.miraiReactInit();
      }

      engine._reactCreateLoadingObserver(function () {
        if (!thn.data.miraiInitialized) { // Init if not already done
          thn.miraiReactInit();
        } else if (ctx.widget.refresh() && !ctx.widget.isSet()) { // Just refresh PW
          ctx.widget.hide();
        }
      });

      thn.pageUnload(function () {
        delete thn.miraiReactInit;
        delete thn.data.miraiReactInitialized;
      });

    } else {
      const $ = window.jQuery;

      if (!$) { return; }
      // Mobile version does more complex stuff in thn.onHashChange()
      // and thn.generic_page_observe_dom()
      if (window.location.pathname.match(/mobile/i)) {
        // Detect currency changes
        $('#currencySelector1').change(function () {
          ctx.widget.logger.debug('*************** Currency Changed **************');
          setTimeout(() => ctx.widget.update(), 1000);
        });

        const $rooms = $('[id=showBookingRoomsMobile]:visible');

        // if rooms html is not ready
        ctx.widget.setData();
        if ($rooms.length && !ctx.widget.isSet()) {

          const observer = function () {
            ctx.widget.logger.debug('*************** DOM Changed **************');
            ctx.widget.setData();
            if (ctx.widget.isSet()) {
              ctx.widget.show();
              // if price if finally here, remove the observer
              thn.stopObserveDom($rooms.get(0), observer);
            }
          };
          thn.observeDom($rooms.get(0), observer);

          // observe for a maximum of 4s
          setTimeout(function removeMiraiMobileObserver() {
            ctx.widget.logger.debug('*************** DOM Observation timedout **************');
            thn.stopObserveDom($rooms.get(0), observer);
          }, 4000);
        }
      } else if (!thn.data.miraiInitialized) { // Desktop version

        thn.data.miraiInitialized = true;
        const $doc = $(document);

        if ($.fn.on) {
          $doc.on('click', '.mirai_button.selectRoom', () => ctx.widget.minimize());
          $doc.on('click', '#currencyDropdownContents li:not(.actualCurrency)', () => ctx.widget.update());
        } else {
          $doc.delegate('.mirai_button.selectRoom', 'click', () => ctx.widget.minimize());
          $doc.delegate('#currencyDropdownContents li:not(.actualCurrency)', 'click', () => ctx.widget.update());
        }

        const $loader = $('#mirai_loadingBox');
        if ($loader.length) {
          thn.miraiLoaderObserver = thn.debounce(function thnMiraiLoaderObserver() {
            ctx.widget.logger.debug('*************** DOM Changed **************');
            if (!$loader.is(':visible')) {
              ctx.widget.update();
            } else {
              ctx.widget.remove();
            }
          }, 250);

          thn.observeDom($loader.get(0), thn.miraiLoaderObserver, {
            childList: false,
            subtree: false,
            characterData: false,
            attributes: true,
            attributeFilter: ['class', 'style'],
          });

          thn.pageUnload(function () {
            thn.stopObserveDom($loader.get(0), thn.miraiLoaderObserver);
            delete thn.miraiLoaderObserver;
            delete thn.data.miraiInitialized;
          });
        }
      }
    }

    thn.pageUnload(function () {
      // Unload the PW for proper loading when returning to R&R
      ctx.widget.reset();
    });

    // Some properties need to refresh the mapping to deconfigure the tools and review the conditions again
    const containerRooms = document.querySelector('.mi-rs');
    const propertiesForcePage = [1012828];

    if (containerRooms && propertiesForcePage.includes(thn.data.propertyId)) {
      let recheckPage = thn.debounce(() => {
        thn.pageCheck({ force: true });
      }, 500);

      thn.observeDom(containerRooms, recheckPage, {
        childList: false,
        subtree: false,
        attributes: true,
      });

      thn.pageUnload(function () {
        thn.stopObserveDom(containerRooms, recheckPage);
        recheckPage.cancel();
        recheckPage = null;
      });
    }
    // Observer v4
    const dataLayer = window.dataLayer;
    if (dataLayer) {
      const refreshPrice = ({ message }) => {
        if (message.event === 'mirai.Availability' || message.event === 'mirai.noAvailability' || message[1] === 'add_to_cart') {
          thn.debounce(ctx.widget.refresh(), 800);
        }
      };

      thn.bus.on('dataLayer:push', refreshPrice);

      thn.pageUnload(() => {
        thn.bus.detach('dataLayer:push', refreshPrice);
      });
    }
  };

  engine._priceParseDataCommon = function enginePriceParseDataCommon(ctx) {
    const $ = window.jQuery;
    const widgetData = {};
    const { promocode } = ctx.widget.getPromocode();
    const promocodeBlacklist = {
      // Sunborn Gibraltar
      1015363: ['106605', '106606'],
    };

    // list here hotels which must be flagged as priceSpecial with promocode presence
    const isPromocodeException = [
      1033509, // Hospes hotels
      1033908, // Artiem Hotels
      1001714, // Unico Hotels
      1035832, // Nordotel Hoteles
      1036105, // Pillow Hotels
      1031921, // Alimara Hotel
    ].includes(thn.data.accountUserId)
      || [
        1014923, // Hotel Mac Puerto Marina
        1014922, // Club Mac
        1015212, // Becquer Hotel
        1013924, // Gran Hotel Bilbao
      ].includes(thn.data.propertyId);

    // react versiones
    if (promocode // promocode presence AND
      && (isPromocodeException // whether the property is an exception
        || ( // OR the promocode is blacklisted
          promocodeBlacklist[thn.data.propertyId]
          && (promocodeBlacklist[thn.data.propertyId].includes(promocode)
            || promocodeBlacklist[thn.data.propertyId].some(function (pattern) { return !!promocode.match(new RegExp(pattern)); })
          )
        ))) {
      ctx.widget.logger.warn('Promocode/rate found and handled: priceSpecial flag set');

      widgetData.priceSpecial = 1;
      // non react versiones
    } else if (window.location.search.match(/roomTypeId=[^&]+/)
      || ($ && $('.roomSelectionNotice > a:visible') && $('.roomSelectionNotice > a:visible').length)) {
      widgetData.priceSpecial = 1;
    } else if (!thn.empty(thn.parseUrlParameter('idoffers'))) {
      widgetData.priceSpecial = 1;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_7
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v1 = function priceParseData_v1(ctx) {
    const widgetData = engine._priceParseDataCommon(ctx);
    const dataLayer = window.dataLayer;
    const occupancyArrayBase64 = thn.parseUrlParameter('parties') && atob(thn.parseUrlParameter('parties'));
    const ocupancyArrayJson = occupancyArrayBase64 && JSON.parse(occupancyArrayBase64);
    const currentRoom = thn.parseNumber(document.querySelector('ui-scrollview > ui-view > ui-button [class*=active]')?.parentElement?.childNodes?.[0]?.textContent || '') || 1;
    const data = thn.objectGet(dataLayer, 'mirai.data', { first: false });

    // Dates
    const dateBegin = data?.checkin;
    const dateEnd = data?.checkout;
    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      widgetData.dateEnd = dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    }

    // Guests, Adults & Children
    const specificRoomGuests = data?.lowestRate?.occupation;
    const adults = ocupancyArrayJson?.[currentRoom - 1]?.adults || specificRoomGuests?.numAdults || 2;
    const children = ocupancyArrayJson?.[currentRoom - 1]?.children?.length || specificRoomGuests?.numChildren || 0;

    // Price & currency
    const exchangeRate = thn.parseNumber(data?.exchangeRate);
    const basePrice = thn.parseNumber(data?.lowestRate?.averagePrice);
    const price = thn.parseNumber(basePrice * exchangeRate);
    const currency = thn.parseCurrency(thn.parseCurrency(data?.userCurrency) || document.querySelector('[name=currency]')?.value || thn.parseUrlParameter('currency'));
    const noAvailability = document.querySelector('[class*=unavailability]');

    if (price && currency && dateBegin && dateEnd) {
      widgetData.price = price;
      widgetData.currency = currency;
      widgetData.adults = adults;
      widgetData.children = children;
      widgetData.guests = adults + children;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_7
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v2 = function priceParseData_v2(ctx) {
    // React DESKTOP version
    const widgetData = engine._priceParseDataCommon(ctx);

    if (!thn.data.language) {
      ctx.widget.logger.debug('*************** Redetecting language, PW execution aborted **************');
      return widgetData;
    }

    if (engine._isReact()
      && engine._reactGetDevice() === 'DESKTOP'
    ) {

      if (engine._reactIsLoading()) {
        this.logger.debug('Booking engine still loading...');
        return widgetData;
      }

      // Dates
      const dateBeginFromDatalayer = thn.dataLayerHelper.get('mirai.data.checkin');
      const dateEndFromDatalayer = thn.dataLayerHelper.get('mirai.data.checkout');
      if (dateBeginFromDatalayer && dateEndFromDatalayer) {
        widgetData.dateBegin = dateBeginFromDatalayer.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        widgetData.dateEnd = dateEndFromDatalayer.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      } else {
        const datepickerEl = document.querySelector('.mi-be-datepicker-select');
        if (datepickerEl) {
          widgetData.dateBegin = (datepickerEl.getAttribute('data-start-date') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
          widgetData.dateEnd = (datepickerEl.getAttribute('data-end-date') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        }

        if (!widgetData.dateBegin) {
          const dateBeginEl = document.querySelector('#BE\\.startDate');
          if (dateBeginEl) {
            widgetData.dateBegin = translateDate(dateBeginEl.value, thn.data.language || 'en');
          }
        }

        if (!widgetData.dateEnd) {
          const dateEndEl = document.querySelector('#BE\\.endDate');
          if (dateEndEl) {
            widgetData.dateEnd = translateDate(dateEndEl.value, thn.data.language || 'en');
          }
        }
      }

      // Price
      const priceEls = document.querySelectorAll('.mi-rs-rate-night-price');

      if (priceEls.length) {
        // Currency fallback
        if (!widgetData.currency) {
          const currencyMatch = priceEls[0].textContent.match(/[^\d\s,.]+/);
          if (currencyMatch && currencyMatch.length > 0) {
            widgetData.currency = thn.getCurrencyCode(currencyMatch[0]);
          }
        }

        const ratesBlacklist = {
          // Salles Hotel Aeroport de Girona
          1011810: ['Daytime Use', 'Uso Diurno', 'Utilisation Diurne', 'Us Diürn'],
        };

        const propertyHasRateExceptions = !!(ratesBlacklist[thn.data.propertyId]);

        // Prices
        const prices = Array.from(priceEls).map(function (priceEl) {
          const roomRate = priceEl.closest('.mi-rs-rate');

          // Mark priceSpecial if a different rate was selected (not the first and default checkbox "Room Only" rate).
          if (!roomRate
            || (roomRate.querySelectorAll('input[type="radio"]').length
              && !roomRate.querySelectorAll('input[type="radio"]')[0].checked)) {
            ctx.widget.logger.warn('*************** A different rate was selected: flagging price as "Special Price" **************');
            widgetData.priceSpecial = 1;
          }

          if (propertyHasRateExceptions) {
            let rateTitle;

            rateTitle = roomRate && roomRate.querySelector('.mi-rs-rate-title');
            rateTitle = roomRate && roomRate.textContent.trim();

            if (rateTitle && ratesBlacklist[thn.data.propertyId].some(function (pattern) { return !!rateTitle.match(new RegExp(pattern)); })) {
              return null;
            }
          }

          return {
            priceEl,
            price: thn.parseNumber(priceEl.textContent),
          };
        }).filter((rate) => rate);

        const minPrice = prices.reduce(function (prev, curr) {
          return (curr.price < prev.price) ? curr : prev;
        });

        widgetData.price = minPrice.price;

        const isPestanaHotels = thn.data.accountUserId === 1037953;
        if (isPestanaHotels && !document.querySelector('.mi-switch--active')) {
          widgetData.priceSpecial = 1;
        }

        let guestsEl = minPrice.priceEl;
        guestsEl = guestsEl && guestsEl.closest('.mi-rs-room');
        guestsEl = guestsEl && guestsEl.querySelector('.mi-rs-room-info p span:first-child');
        guestsEl = guestsEl && guestsEl.textContent;

        // Get the guest of the room with min price
        if (guestsEl) {
          let childrenAges = [];
          const guestsInfo = guestsEl.split(' + ');

          widgetData.children = 0;

          for (let i = 0; i < guestsInfo.length; i += 1) {
            const guestDetail = guestsInfo[i].split(' ');
            const guestAmount = parseInt(guestDetail[0], 10);
            const guestType = guestDetail[1] || '';

            if (guestType.match(/(adults?|adultos?)/i)) { // Adults
              widgetData.adults = guestAmount;

            } if (guestType.match(/(child(ren)?|niños?)/i)) { // Children
              const children = guestAmount;

              widgetData.children += children;
              // Add default childrens age
              childrenAges = [...childrenAges, ...Array(children).fill(10)];

            } if (guestType.match(/(bab(y|ies)|bebés?)/i)) { // Babies
              const babies = guestAmount;
              widgetData.children += babies;
              // Add default babies age
              childrenAges = [...childrenAges, ...Array(babies).fill(1)];
            }
          }

          // If there were children, add their ages to widgetData
          if (!thn.empty(childrenAges)) {
            const room1Info = {
              adults: widgetData.adults,
              children: widgetData.children,
              childrenAges,
            };
            // add the room info to the "roomsDispo"
            widgetData.roomsDispo = [room1Info];
          }
        }

        if (widgetData.adults && widgetData.children) {
          widgetData.guests = widgetData.adults + widgetData.children;
        }

        widgetData.roomDetails = engine._roomDetailsParseData();
        widgetData.set = true;

      } else if ((!priceEls.length && document.querySelector('.mi-na-option-dates')) || document.querySelector('.mi-na-availability-others') || (document.querySelector('.mi-na-view-all-results') && [1025044, 1025045].includes(thn.data.propertyId))) {
        widgetData.noRooms = true;
      }

      // Currency
      const currencyEl = document.querySelector('.mi-rs-currency-select span.mi-dropdown-btn') || document.querySelector('.mi-rs-currency-select .Select-value-label, .mi-rs-currency-select label');
      if (!widgetData.currency && currencyEl && currencyEl.textContent) {
        widgetData.currency = thn.parseCurrency(currencyEl.textContent.split('-')[0].trim());
      }

      if ([1044843].includes(thn.data.accountUserId)) {
        const roomsInfo = [...document.querySelectorAll('.mi-rs-room')].map((room) => {
          const occupancyText = room.querySelector('.mi-rs-room-occupation-people-edit')?.textContent;
          let [adults, children] = [2, 0];

          if (occupancyText) {
            [adults, children] = occupancyText.split('+');
          }
          const price = room.querySelector('.mi-rs-rate-night-price')?.textContent;
          let roomInfo;

          if (price) {
            roomInfo = {
              adults: thn.parseNumber(adults),
              children: thn.parseNumber(children),
              price: thn.parseNumber(price),
              childrenAges: [],
            };

            for (let i = 1; i <= roomInfo.children; i += 1) {
              roomInfo.childrenAges.push(10);
            }
          }

          return roomInfo;
        }).filter(Boolean);

        roomsInfo.sort((a, b) => a.price - b.price);

        if (!thn.empty(roomsInfo)) {
          widgetData.price = roomsInfo[0].price;
          widgetData.roomsDispo = [roomsInfo[0]];
        }
      } else if (!widgetData.guests) {
        // try to get adults info from dropdown
        let children;
        let adults;
        let rooms;
        let guestsText = (document.querySelector('.mi-be-multiroom-field.mi-dropdown-button')
          || document.querySelector('label.mi-dropdown') || {}).textContent;
        guestsText = guestsText && guestsText.split(',');

        if (guestsText) {

          // guests_text contains: [0] = rooms & adults, [1] = children
          // Separate rooms from adults, reverse in order to have the adults at index 0 in case "rooms" is present
          const textTmp = (guestsText[0].match(/\d{1,2}\s/g) || []).reverse();

          adults = thn.parseNumber(textTmp[0]);
          rooms = (textTmp.length === 2 && thn.parseNumber(textTmp[1]));

          if (guestsText.length === 1 && !adults) {
            // The dropdown sometimes shows "others" instead of the number of adults
            // In this case try to get the guests from the suggested room
            let guests = document.querySelector('.mi-rs-room-info')
              && document.querySelector('.mi-rs-room-info').textContent;

            if (guests && guests.match(/adult/)) { // Some rooms have option of children and some others doesn't difference between adults and child
              guests = guests.replace(/([^0-9])+/g, ' ').trim().split(' ');
              adults = parseInt(guests[0], 10);
              children = parseInt(guests[1], 10);
            } else if (guests && guests.match(/guest/)) {
              adults = thn.parseNumber(guests);
            }

          } else if (guestsText.length === 2) {
            // Rooms, adults & children text
            children = thn.parseNumber(guestsText[1]);
          }
        }

        widgetData.rooms = rooms || 1;
        widgetData.adults = adults || 2;
        widgetData.children = children || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
      }
    }
    return widgetData;
  };

  /**
     * @memberOf module:bs_7
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v3 = function priceParseData_v3(ctx) {
    // React MOBILE version
    const widgetData = engine._priceParseDataCommon(ctx);

    if (!thn.data.language) {
      ctx.widget.logger.debug('*************** Redetecting language, PW execution aborted **************');
      return widgetData;
    }

    if (engine._isReact()
      && engine._reactGetDevice() === 'MOBILE'
    ) {
      // dates
      const checkin = thn.parseUrlParameter('checkin') || thn.dataLayerHelper.get('mirai.data.checkin');
      const nights = thn.parseUrlParameter('nights') || thn.dataLayerHelper.get('mirai.data.checkout');
      if (checkin && nights) {
        widgetData.dateBegin = checkin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, nights));
      }

      // guests
      const guestsEl = document.querySelector('.mim-go-back__intro span, .mim-go-back__guests strong, .mi-rs-room-info span');
      const guests = (guestsEl && guestsEl.textContent);
      widgetData.adults = (guests && thn.parseNumber(guests)) || 2;
      widgetData.children = (guests && guests.split('+')[1] && thn.parseNumber(guests.split('+')[1])) || 0;
      widgetData.guests = widgetData.adults + widgetData.children;

      if (widgetData.children) {
        const room1Info = {
          adults: widgetData.adults,
          children: widgetData.children,
          childrenAges: ((guests.split('(')[1] && guests.split('(')[1].split(' ')) || []).filter((el) => parseInt(el, 10)).map((el) => parseInt(el, 10)),
        };

        widgetData.roomsDispo = [room1Info];
      }

      // currency
      const currency = document.querySelector('.mim-header__currency-selector option.is-selected')
        || document.querySelector('.mi-rs-currency-select');
      widgetData.currency = currency && thn.getCurrencyCode(currency.textContent.split('-')[0].trim() || '');

      // prices

      let pricesArr = [];

      const pricesOp1 = [...document.querySelectorAll('.mim-rs-rate-boards__price')];
      const pricesOp2 = [...document.querySelectorAll('.mi-rs-rate-night-price')];
      const priceEls = pricesOp1.length ? pricesOp1 : pricesOp2;

      if (priceEls.length) {

        priceEls.forEach((priceEl) => {
          // price_els can have 2 childnodes with nodeType span or text, span are strikedthough. If only 1 node, no strikethrough prices.
          const price = (priceEl.childNodes.length && priceEl.childNodes.length > 1 && priceEl.childNodes[1].nodeType === 3 ? priceEl.childNodes[1].textContent : priceEl.childNodes[0].textContent);
          pricesArr.push(thn.parseNumber(price || ''));
        });

        pricesArr = pricesArr.filter((el) => el);
      }

      if (pricesArr.length) {
        widgetData.price = Math.min(...pricesArr);
        widgetData.roomDetails = engine._roomDetailsParseData();
        widgetData.set = true;

      } else if (document.querySelector('.mim-alert__message')) {
        widgetData.noRooms = true;
      }
    }
    return widgetData;
  };

  /**
     * @memberOf module:bs_7
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v4 = function priceParseData_v4(ctx) {
    // classic versions with Jquery
    const $ = window.jQuery;
    const widgetData = engine._priceParseDataCommon(ctx);

    if (!thn.data.language) {
      ctx.widget.logger.debug('*************** Redetecting language, PW execution aborted **************');
      return widgetData;
    }

    if ($ && !engine._isReact()) {
      const bookingMobileUrl = $('[id=showBookingRoomsMobile]:visible').data('url');

      // Prices & Guests
      const $container = $('#mirai_roomSelectionContainer');
      const $prices = $('.ratesTable .selectRoom');
      const $nodispo = $('#noDispo:visible');
      const $loader = $('#mirai_loadingBox:visible');

      // React elements (New 2018-05-07)
      const $containerRs = $('.mi-rs-results');
      const $nodispoRs = $('.mi-na-message .mi-ico-alert');
      const loadingRs = engine._reactIsLoading();

      let minGuests = 1;

      //  Hotels that do not want the 1 guest room
      const propertiesDoubleBased = [
        1011060, //  Carlos V
        1000536, 1000537, 1000538, //  Gloria Palace
        1011998, // Hostal Las Fuentes
      ];

      if (propertiesDoubleBased.includes(thn.data.propertyId)) {
        minGuests = 2;
      }

      // Dates
      if (bookingMobileUrl && thn.parseUrlParameter('checkin', bookingMobileUrl)) {
        widgetData.dateBegin = thn.parseUrlParameter('checkin', bookingMobileUrl).replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

        widgetData.nights = parseInt(thn.parseUrlParameter('nights', bookingMobileUrl), 10) || 1;

        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, widgetData.nights));

      } else if (document.querySelector('.mi-be-datepicker-select')) {
        const datepickerEl = document.querySelector('.mi-be-datepicker-select');

        widgetData.dateBegin = (datepickerEl.getAttribute('data-start-date') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        widgetData.dateEnd = (datepickerEl.getAttribute('data-end-date') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

      } else if ($('.DateInput_input').length > 0) {
        // React Version
        const datesSelector = $('.DateInput_input');

        widgetData.dateBegin = translateDate(datesSelector.eq(0).val(), thn.data.language || 'en');
        widgetData.dateEnd = translateDate(datesSelector.eq(1).val(), thn.data.language || 'en');

      } else if (document.querySelector('[name="checkin"]') && document.querySelector('[name="checkin"]').value) {
        widgetData.dateBegin = document.querySelector('[name="checkin"]').value.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

        const nightsEl = document.querySelector('[name=nights]');
        widgetData.nights = (nightsEl && parseInt(nightsEl.value, 10)) || 1;

        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, widgetData.nights));

      } else if (thn.parseUrlParameter('checkin')) {
        widgetData.dateBegin = thn.parseUrlParameter('checkin').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

        widgetData.nights = parseInt(thn.parseUrlParameter('nights'), 10) || 1;

        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, widgetData.nights));

      } else {
        widgetData.dateBegin = thn.parseUrlParameter('checkin', window.location.hash).replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

        widgetData.nights = parseInt(thn.parseUrlParameter('nights', window.location.hash), 10) || 1;

        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, widgetData.nights));
      }

      // Prices
      if (window.location.pathname.match(/mobile/i)) { // Mobile version

        if ($('[id=showBookingRoomsMobile]:visible').length > 0) {
          $('.toBookingRatesMobile .ui-btn-text').each(function (index, element) {
            if ((typeof widgetData.price === 'undefined') || (widgetData.price > thn.parseNumber(element.innerHTML.replace(/<[^>]*>/g, '')))) {
              widgetData.price = thn.parseNumber(element.innerHTML.replace(/<[^>]*>/g, ''));
            }
          });
        }

        /**
                 * Guests (mobile version)
                 * Try to get adults first from the URL
                 * 2018-11-29: Sometimes, searches does not provide all the information in the URL. Try to get
                 * the data from three variables named:
                 * - numAdultsOccupation (adults)
                 * - numFirstRangeChildrenOccupation (children 3-5 years)
                 * - numSecondRangeChildrenOccupation (children 6-12 years)
                 * - numBabiesOccupation (babies)
                 * 2019-10-29: Data in URL does not refresh on new search, removed parseUrlParameter fallbacks
                 */
        widgetData.adults = parseInt(window.numAdultsOccupation, 10) || 2;

        // If selected, try to get the children too
        const children1 = parseInt(window.numFirstRangeChildrenOccupation, 10) || 0;
        const children2 = parseInt(window.numSecondRangeChildrenOccupation, 10) || 0;
        const babies = parseInt(window.numBabiesOccupation, 10) || 0;

        widgetData.children = children1 + children2 + babies;

        // If there are children, set the ages
        if (widgetData.children) {
          let children1Age = 10;
          let children2Age = 10;

          let guestsData = window && window.hotelsGuestOptions;
          guestsData = guestsData && guestsData[Object.keys(guestsData)[0]];

          if (guestsData) {
            if (guestsData.firstRangeChildrenAge && Array.isArray(guestsData.firstRangeChildrenAge) && guestsData.firstRangeChildrenAge.length >= 2) {
              children1Age = parseInt((guestsData.firstRangeChildrenAge[0] + guestsData.firstRangeChildrenAge[1]) / 2, 10); // Median
            }

            if (guestsData.secondRangeChildrenAge && Array.isArray(guestsData.secondRangeChildrenAge) && guestsData.secondRangeChildrenAge.length >= 2) {
              children2Age = parseInt((guestsData.secondRangeChildrenAge[0] + guestsData.secondRangeChildrenAge[1]) / 2, 10); // Median
            }
          }

          const room1Info = {
            adults: widgetData.adults,
            children: widgetData.children,
            childrenAges: [
              ...Array(children1).fill(children1Age),
              ...Array(children2).fill(children2Age),
              ...Array(babies).fill(1),
            ],
          };
          // add the room info to the "roomsDispo"
          widgetData.roomsDispo = [room1Info];
        }

        // Set guests
        widgetData.guests = widgetData.adults + widgetData.children;

      } else if ($container.css('visibility') && $container.css('visibility') !== 'hidden' && $prices.length && $nodispo.length === 0 && $loader.length === 0) {
        let bestRate = Number.MAX_VALUE;
        let adults;

        //  map all prices to a {adults, price} list
        $prices.map(function (idx, priceEl) {
          const $priceEl = $(priceEl);
          const price = parseFloat(`${$('.integerPart', $priceEl).text()}.${$('.decimalPart', $priceEl).text()}`);
          const priceId = $priceEl.closest('tbody[id]').attr('id').match(/\d+/)[0];

          const $priceAdults = $(`#select_roomTypeId_${priceId} option:selected`).length
            ? $(`#select_roomTypeId_${priceId} option:selected`)
            : $(`#images_${priceId}`).closest('tr').find('.paxWrapper');
          const priceAdults = ($priceAdults.length && (parseInt($priceAdults.text().match(/\d+/)[0], 10) || 2))
            || 1;

          return {
            adults: priceAdults,
            price,
          };
          //  filter the prices by minimum guests
        }).filter(function (idx, el) {
          return el.adults >= minGuests;
          //  search the cheapest option
        }).each(function (idx, el) {
          if (el.price < bestRate) {
            bestRate = el.price;
            adults = el.adults;
          }
        });

        if (bestRate !== Number.MAX_VALUE) {
          widgetData.price = bestRate;

          widgetData.adults = adults || 2;
          widgetData.children = 0;
          widgetData.guests = widgetData.adults + widgetData.children;
        }

      } else if ($containerRs.css('visibility') && $containerRs.css('visibility') !== 'hidden' && $nodispoRs.length === 0 && !loadingRs) {
        const $pricesRs = $('.mi-rs-room');
        let bestRateRs = Number.MAX_VALUE;
        let guestsRs = 2;
        let adultsRs = 2;
        let childrenRs = 0;

        //  map all prices to a {guests, price} list
        $pricesRs.map(function (idx, el) {
          const $el = $(el);
          const roomPricesRs = $el.find('.mi-rs-rate-night-price').map(function (idx2, priceEl) {
            /* Check if price has more than 3 decimals.
                        * Leave just two decimals, so the thn parse function works as expected.
                        */
            let priceVal = priceEl.textContent.trim();
            if (priceVal.match(/[.,]\d{3}$/)) {
              priceVal = priceVal.slice(0, -1);
            }
            return thn.parseNumber(priceVal);
          });
          const price = Math.min(...roomPricesRs);
          const selectorText = $('.mi-be-multiroom-select .mi-dropdown').text().split(',');
          const room = {};

          // Default selector
          if (selectorText && selectorText.length > 1) {
            // TODO Children age
            let adults = selectorText[0] || 2; // By default
            let children = 0; // By default
            const guestsEl = $el.find('.mi-rs-room-info span').eq(0).text();
            if (guestsEl) {
              const guestsElParts = guestsEl.split('+');
              if (guestsElParts.length > 1) {
                // If length is greater than 1, it means that children exist
                adults = thn.parseNumber(guestsElParts[0]);
                children = thn.parseNumber(guestsElParts[1]);
                if (guestsElParts.length > 2) {
                  // Count the third argument too, as there may be babies
                  children += thn.parseNumber(guestsElParts[2]);
                }
              } else {
                // Else, only adults
                adults = thn.parseNumber(guestsEl[0]);
              }
            }
            room.adults = adults;
            room.children = children;

            // Selector contains number of rooms and adults
          } else if (selectorText && selectorText.length === 1) {
            const text = selectorText[0];
            room.adults = thn.parseNumber((text.split('.') || [])[1])
              || thn.parseNumber(text.split(' ')[2])
              || 2;
            // Children or babies are not selectable
            room.children = 0;
          }

          room.guests = room.adults + room.children;
          room.price = price;

          return room;
          //  filter the prices by minimum guests
        }).filter(function (idx, el) {
          return el.guests >= minGuests;
          //  search the cheapest option
        }).each(function (idx, el) {
          if (el.price < bestRateRs) {
            bestRateRs = el.price;
            guestsRs = el.guests;
            adultsRs = el.adults;
            childrenRs = el.children;
          }
        });

        if (bestRateRs !== Number.MAX_VALUE) {
          widgetData.price = bestRateRs;
          widgetData.guests = guestsRs;
          widgetData.adults = adultsRs;
          widgetData.children = childrenRs;
        }
      } else if (
        ($container.css('visibility') !== 'hidden' || $containerRs.css('visibility') !== 'hidden')
        && (($nodispo.length && !$loader.length) || ($nodispoRs.length && !loadingRs))
        && thn.empty(this.getPromocode())
      ) {
        widgetData.noRooms = true;
      }

      // Currency
      if ((document.getElementById('currencyDropdownTop') != null) && (document.getElementById('currencyDropdownTop').getElementsByTagName('span').length > 0)) {
        widgetData.currency = document.getElementById('currencyDropdownTop').getElementsByTagName('span')[0].className;
      } else if (($.isFunction($)) && ($('.pAbsolute.pBottom.pRight').length > 0)) {
        widgetData.currency = $('.pAbsolute.pBottom.pRight').text().trim();
      } else if (document.getElementsByClassName('currency-type').length) {
        widgetData.currency = document.getElementsByClassName('currency-type')[0].textContent.trim();
      } else if (document.getElementById('currencySelector1')) {
        widgetData.currency = document.getElementById('currencySelector1').value;
      } else {
        const currencyEl = document.querySelector('.mi-rs-currency-select .Select-value-label, .mi-rs-currency-select label')
          || (document.getElementsByClassName('mi-rs-rate-night-price').length && document.getElementsByClassName('Select-value-label')[1]);

        if (currencyEl && currencyEl.textContent) {
          widgetData.currency = thn.getCurrencyCode(currencyEl.textContent.split('-')[0].trim());
        }
      }

      // ¿Is it set?
      if (widgetData.price && widgetData.dateBegin && widgetData.dateEnd && widgetData.guests) {

        // Make sure day and month have length === 2
        if (widgetData.dateBegin && widgetData.dateEnd) {

          widgetData.dateBegin = widgetData.dateBegin
            .split('/').map((num) => (num.length < 2 ? `0${num}`.slice(-2) : num)).join('/');
          widgetData.dateEnd = widgetData.dateEnd
            .split('/').map((num) => (num.length < 2 ? `0${num}`.slice(-2) : num)).join('/');
        }
        widgetData.roomDetails = engine._roomDetailsParseData();
        widgetData.set = true;
      } else if (!widgetData.price && document.querySelector('#validationErrorsMobile')) {
        widgetData.noRooms = true;
      }
    }
    return widgetData;
  };

  /**
     *
     * @memberOf module:bs_7
     *
     */
  engine._roomDetailsParseData = function roomDetailsParseData() {
    const roomsInfoEl = [...document.querySelectorAll('.mi-rs-room, .mim-rs-room')];
    const dataLayer = window.dataLayer;

    // Guests
    const roomAdults = (dataLayer && thn.objectGet(dataLayer, 'numAdults', { first: false })) || 2;
    const roomChildren = (dataLayer && thn.objectGet(dataLayer, 'numChildren', { first: false })) || 0;

    // Rooms
    if (roomsInfoEl.length === 0) {
      return undefined;
    }

    const getRoomType = (name = '') => {
      if (name.toLowerCase().includes('suite')) {
        return 'suite';
      }
      if (name.toLowerCase().includes('superior')) {
        return 'superior';
      }
      return 'standard';
    };
    const isBreakfastEl = (item) => {
      const radioBtnEl = [...item.querySelectorAll('.mi-rs-radio-boards')].filter((el) => el.querySelectorAll('.mi-radio-container')[1]?.querySelector('input[type=radio]:checked'));
      const paragraphEl = [...item.querySelectorAll('.mi-rs-text-boards p')].filter((el) => el.textContent.match(/Desayuno|Breakfast|Petit|Frühstück/));
      const paragraphElMobile = [...item.querySelectorAll('.mim-rs-rate-boards')].map((el) => el.querySelector('td')).filter((it) => it.textContent.match(/Desayuno|Breakfast|Petit|Frühstück/));
      if (radioBtnEl.length || paragraphEl.length || paragraphElMobile.length) {
        return 1;
      }
      return 0;
    };
    const isRefundableEl = (item) => {
      const refundableEl = [...item.querySelectorAll('.mi-rs-rate-info span, .mim-rs-rate-header__message .mim-rs-rate-header__info')].filter((el) => el.textContent.match(/gratis|Free|gratuite|Kostenlose/));
      return refundableEl.length ? 1 : 0;
    };

    const roomDetailsArray = roomsInfoEl.map((element) => {
      const roomName = element.querySelector('.mi-rs-room-header .mi-rs-room-info h2, .mim-rs-room-header .mim-rs-room-header__title')?.textContent;
      const roomType = getRoomType(roomName);
      const roomId = ''; // there are is no room id element available
      const priceSelector = [...element.querySelectorAll('.mi-rs-rates-listing .mi-rs-rate, .mim-rs-rates-list-wrapper .mim-rs-rate-wrapper')];
      const priceInfo = priceSelector && priceSelector.map((item) => {
        const priceItemName = item.querySelector('.mi-rs-rate-title, .mim-rs-rate-header__title')?.textContent || '';
        const priceEl = item.querySelector('.mi-rs-rate-night-price, .mim-rs-rate-boards__price')?.textContent || '';
        const price = priceSelector && thn.parseNumber(priceEl);
        const isBreakfast = isBreakfastEl(item);
        const isRefundable = isRefundableEl(item);
        const priceData = {
          id: '',
          name: priceItemName,
          totalNight: price,
          breakfast: isBreakfast,
          refundable: isRefundable,
        };
        return priceData;
      });

      const roomData = {
        id: roomId,
        name: roomName,
        adults: roomAdults,
        children: roomChildren,
        type: roomType,
        prices: priceInfo,
      };
      return roomData;
    });

    return roomDetailsArray;
  };

  engine.bookingObserveDom = function bookingObserveDom(ctx) {
    if (engine._isReact()) {
      // Wait for loading
      engine._reactCreateLoadingObserver(function () {
        // After loading, execute booking_parse_data
        if (ctx.widget.setData().isSet()) {
          ctx.widget.save();
        }
      });
    }
  };

  engine.bookingParseData = function bookingParseData(ctx) {
    const widgetData = {};
    const $ = window.jQuery;
    const isGranBilbaoCallCenterBooking = !!window.location.hostname.match(/callcenter.hotelgranbilbao/);
    const reservationCodeExpiredElm = !!document.querySelector('.mi-rc-reservation-code-expired');

    // Engine is still loading
    // Should not record bookings from the call center for Gran Bilbao
    if ((engine._isReact() && engine._reactIsLoading()) || isGranBilbaoCallCenterBooking || reservationCodeExpiredElm) {
      if (isGranBilbaoCallCenterBooking) {
        thn.logger.debug('*********** This is a booking from the call center. ***********');
      }
      widgetData.set = false;
      return widgetData;
    }

    // ID
    const bookingIdEl = document.querySelector('.mi-rc-reservation-code-data span');
    widgetData.bookingId = thn.parseUrlParameter('reservationCode')
      || (bookingIdEl && bookingIdEl.textContent);

    if (window.dataLayer) {
      // Dates
      const dateBegin = (thn.dataLayerHelper.get('checkin') || '').replace(/-/gi, '/');
      const dateEnd = (thn.dataLayerHelper.get('checkout') || '').replace(/-/gi, '/');

      if (dateBegin) {
        widgetData.dateBegin = dateBegin.match(/\d{4}\/\d{2}\/\d{2}/) ? dateBegin : dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      }

      if (dateEnd) {
        widgetData.dateEnd = dateEnd.match(/\d{4}\/\d{2}\/\d{2}/) ? dateEnd : dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      }

      // Price
      widgetData.price = thn.dataLayerHelper.get('totalPrice');
      // Currency
      widgetData.currency = thn.dataLayerHelper.get('currency');
    }

    if (!widgetData.dateBegin || !widgetData.dateEnd) {

      const dateBegin = ((document.querySelector('.mi-rc-reservation-code-date-checkin') || {}).textContent || '').split(',');
      const dateEnd = ((document.querySelector('.mi-rc-reservation-code-date-checkout') || {}).textContent || '').split(',');
      const occupancyArray = document.querySelector('.mi-rc-reservation-detail-people')?.textContent?.split('+');
      widgetData.adults = thn.parseNumber(occupancyArray?.[0]);
      widgetData.children = thn.parseNumber(occupancyArray?.[1]);

      // Dates
      widgetData.dateBegin = ($ && $('#confirmationPage tr:eq(3) td:eq(1)').text()) || (dateBegin.length > 1 && dateBegin[1]);
      if (!widgetData.dateBegin) {
        const match = $ && $('.listConf:eq(0) li:eq(2)').text().match(/([0-9]){2}-([a-zA-Z]){3}-([0-9]){4}|([a-zA-Z]){3} ([0-9]){2}, ([0-9]){4}/g);
        widgetData.dateBegin = (match && match[0]) || '';
      }
      widgetData.dateBegin = translateDate(widgetData.dateBegin, thn.data.language || 'en');

      widgetData.dateEnd = ($ && $('#confirmationPage tr:eq(4) td:eq(1)').text()) || (dateEnd.length > 1 && dateEnd[1]);
      if (!widgetData.dateEnd) {
        const match = $ && $('.listConf:eq(0) li:eq(3)').text().match(/([0-9]){2}-([a-zA-Z]){3}-([0-9]){4}|([a-zA-Z]){3} ([0-9]){2}, ([0-9]){4}/g);
        widgetData.dateEnd = (match && match[0]) || '';
      }
      widgetData.dateEnd = translateDate(widgetData.dateEnd, thn.data.language || 'en');

      const priceText = ($ && $('.tRight.width6em.fontBold, #totalPrice span:not(.taxesInfo):not(.dateDetails)').eq(0).text().trim())
        || (document.querySelector('.mi-rc-reservation-price-total') || {}).textContent;

      if (priceText) {
        // Price
        widgetData.price = thn.parseNumber(priceText);
        // Currency
        widgetData.currency = thn.getCurrencyCode(priceText?.match(/[^\d\s,.]+/)[0]);
      }
    }
    return widgetData;
  };

  engine.getPromocode = function getPromocode(ctx) {
    let lang;
    const dataLayer = window.dataLayer;
    const miraiData = window.Mirai;
    const promocode = (document.querySelector('.mi-be-promo-field input') || {}).value
      || (dataLayer && thn.objectGet(dataLayer, 'cuopon', { depth: 3 })) // too inside to use thn.dataLayerHelper.get, si si, cuopon
      || (dataLayer && thn.objectGet(dataLayer, 'coupon', { depth: 3 }))
      || (dataLayer && thn.dataLayerHelper.get('mirai.data.coupon'))
      || (miraiData && miraiData.urlParameters && (miraiData.urlParameters.idoffers || miraiData.urlParameters.clientCode))
      || ((lang = window.location.href.match(/idoffers=(\d+)&/)) && lang.length >= 2 && lang[1]);

    if (promocode) {
      ctx.promocode = promocode;
    }
    return ctx.promocode;
  };
  return engine;
}

export { factory };
